// document.querySelector(".js-nav-button").addEventListener("click", (e) => {
//     document.querySelector(".js-nav").classList.toggle("header__menu--is-active");
//     e.currentTarget.classList.toggle("hamburger--is-active");
//     document.body.classList.toggle("mobile-nav-open");
// });

// const items = document.querySelectorAll('.header__menu-link');

// for (const item of items) {
//     item.addEventListener("click", e => {
//         if (e.currentTarget.parentNode.classList.contains("header__menu-item--has-children")) {
//             e.preventDefault();
//         }
//     })

// }



const navElement = document.querySelector(".js-nav-v2");
const links = navElement.querySelectorAll(".nav-v2__items .nav-v2__items-heading");
const searchButton = document.querySelector(".js-search-button");
const searchBar = document.querySelector(".js-search");
const navButton = document.querySelector(".js-nav-button");
const searchInput = document.querySelector(".js-search input");


function addDesktopEvents(links) {
  // Mouse over links
  links.forEach(element => {
    element.parentNode.addEventListener("mouseenter", () => {
        element.parentNode.classList.add("nav-v2__items--show");
    });

    element.parentNode.addEventListener("mouseleave", () => {
      element.parentNode.classList.remove("nav-v2__items--show");
    });
  });
}

function hideAll(links) {
  links.forEach(item => item.parentNode.classList.remove("nav-v2__items--show"));
}

function addMobileEvents(links) {
  links.forEach(element => {
    element.addEventListener("click", e => {

      if (e.currentTarget.parentNode.classList.contains("nav__items--has-children")) {
       	e.preventDefault(); 
      }
      
      hideAll(links);
      element.parentNode.classList.add("nav-v2__items--show");
    })
  });
}

searchButton.addEventListener("click", e => {
  e.preventDefault();
  navButton.classList.remove("hamburger--is-active")
  navElement.classList.remove("header-v2__nav--active");

  if (!searchButton.classList.contains("header-v2__search-icon--close")) {
    searchBar.classList.add("header-v2__search--show");
    searchButton.classList.add("header-v2__search-icon--close");
    searchInput.focus();

  } else {
    searchBar.classList.remove("header-v2__search--show"); 
    searchButton.classList.remove("header-v2__search-icon--close");
  }

});


navButton.addEventListener("click", e => { 
  
  searchBar.classList.remove("header-v2__search--show");
  searchButton.classList.remove("header-v2__search-icon--close");
  e.currentTarget.classList.toggle("hamburger--is-active")
  navElement.classList.toggle("header-v2__nav--active");
  
  document.body.classList.toggle("menu-is-open");
});


const mql = window.matchMedia("(min-width: 992px)");

if (mql.matches) {
  addDesktopEvents(links);
} else {
  addMobileEvents(links);
}

try {
  mql.addEventListener("change", e => {
    console.log(e)
    if (mql.matches) {
      addDesktopEvents(links);
    } else {
      addMobileEvents(links);
    }

  });

} catch (err) {
  mql.addListener(e => {
    if (mql.matches) {
      addDesktopEvents(links);
    } else {
      addMobileEvents(links);
    }
  });
}

// // This is for the OLD menu.
// document.querySelector(".js-nav-button").addEventListener("click", (e) => {

//     // TODO: remove for A/B test
//     if (e.currentTarget.parentNode.classList.contains("header__container--show-b")) {
//         return;
//     }

//     document.querySelector(".js-nav").classList.toggle("header__menu--is-active");
//     e.currentTarget.classList.toggle("hamburger--is-active");
// });

// const items = document.querySelectorAll('.header__menu-link');

// for (const item of items) {
//     item.addEventListener("click", e => {
//         if (e.currentTarget.parentNode.classList.contains("header__menu-item--has-children")) {
//             e.preventDefault();
//         }
//     });

// }